import React, { Component, PropTypes } from 'react'

import WidgetMaker from './widget-maker'

// app__container + app__footer
const WIDGET_HEIGHT = 490 + 40
const WIDGET_MEDIUM = 'backlink'

class WidgetMakerContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      format: 'compact',
      type: 'dynamic',
      width: '100%',
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange(name, value) {
    this.setState({ [name]: value })
  }

  getDynamicSnippet() {
    const { linkSlug, whitelabelUrl } = this.props
    const { format, width } = this.state

    // eslint-disable-next-line max-len
    return `<!-- Put this code where you want the widget to appear. -->
<a href="${whitelabelUrl}" data-yplan="widget" data-format="${format}" data-width="${width}"></a>

<!-- Put this at the bottom of the page, just before the </body> tag. -->
<script src="//yplanapp.com/affiliate/v1/widget.js"></script>
<script>YPlan.register({
  partnerId: '${linkSlug}',
  medium: '${WIDGET_MEDIUM}',
});</script>`
  }

  getStaticSnippet() {
    const { linkSlug, whitelabelUrl } = this.props
    const { format, width } = this.state

    let url = whitelabelUrl
    url += '/embed?'
    url += `medium=${WIDGET_MEDIUM}&`
    url += `partnerId=${linkSlug}&`
    url += `format=${format}&`
    url += `fixed=${this.isFixed()}`

    return `<iframe src="${url}" width="${width}" height="${WIDGET_HEIGHT}px" frameborder="0"></iframe>`
  }

  isFixed() {
    const { type } = this.state

    return type === 'static'
  }

  render() {
    const { type } = this.state

    return (
      <WidgetMaker
        {...this.state}
        snippet={type === 'static' ? this.getStaticSnippet() : this.getDynamicSnippet()}
        onChange={this.onChange}
      />
    )
  }

}

WidgetMakerContainer.propTypes = {
  linkSlug: PropTypes.string,
  whitelabelUrl: PropTypes.string,
}

export default WidgetMakerContainer



/** WEBPACK FOOTER **
 ** ./src/components/widget-maker/widget-maker-container.js
 **/